module.exports = __webpack_public_path__ + "img/car_2 - 副本.1666f40c.png";